import React, { useState, useMemo, useEffect } from 'react';
import {
    Button,
    Widget,
    GridView,
    SimpleView,
    Table,
    FormInput,
    ColumnProps,
    MasterDetailForm,
    FormSubmitButton,
    FormatText,
    FormSelect
} from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import { ControleRfa, getAllProjetoPlanilhaRfaAtual, creatPrograma, Programa, ProgramaControleRfa, getAllPrograma, deletePrograma } from '@app/api/programa';
import * as Yup from 'yup';


const Programa = () => {
    const [controleRfa, setControleRfa] = useState<ControleRfa[]>();
    const [resulProgramaControleRfa, setProgramaControleRfa] = useState<ProgramaControleRfa[]>();

    useEffect(() => {
        getAllContrleRfa();
        getAllProgramaControleRfa();
    }, []);


    const getAllProgramaControleRfa = () => {
        getAllPrograma().then((data) => {
            setProgramaControleRfa(data);
        });
    }

    const getAllContrleRfa = async () => {
        getAllProjetoPlanilhaRfaAtual().then((data) => {
            setControleRfa(data);
        });
    };

    const postPrograma = (values: any) => {
        const form = values as Programa;
        creatPrograma(form).then((data) => {
            getAllProgramaControleRfa();
        });

    }

    const hasDeletar = (id: string) => {
        deletePrograma(id).then((data) => {
            getAllProgramaControleRfa();
        });
    }

    const validationSchema = Yup.object().shape({
        nome: Yup.string()
            .required('Nome requerido')
            .min(3, 'O nome deve ter no mínimo 3 caracteres.'),
    });

    const colluns = () => {
        let colluns: ColumnProps<ProgramaControleRfa>[] = new Array();

        colluns.push(
            {
                title: 'N',
                dataIndex: 'numeroLinha',
                width: 2,
            });

        colluns.push(
            {
                title: 'Código',
                dataIndex: 'codigo',
                width: 2,
            });

        colluns.push(
            {
                title: 'NOME',
                dataIndex: 'nomePrograma',
                width: '',
            });


        colluns.push(
            {
                title: 'Controle RFA',
                dataIndex: 'planilhaRfa',
                width: '30%',
            });

        colluns.push({
            title: `Ação`,
            align: 'center',
            width: 2,
            render: (text, row, index) => {
                return (
                    <>
                        <Button
                            onClick={() => hasDeletar(row.id)}
                            icon="commons-search"
                            confirm="Deseja realmente excluir este registro?"
                            okText="Excluir"
                        />
                    </>
                );
            },
        });


        return colluns;
    }

    return (
        <SimpleView >
            <GridView
                noform>
                <MasterDetailForm
                    validationSchema={validationSchema}
                    initialValues={[]}
                    onSubmit={values => {
                        postPrograma(values);
                    }}>
                    <Widget
                        actions={[
                            hasPermission([
                                'DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR',
                                'DIRETORIA_AREA_DEPARTAMENTO_EDITAR',
                            ]) && (
                                <FormSubmitButton type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>

                            ),
                        ]}>
                        <FormInput label="Código" name="codigo" span={2} />
                        <FormInput label="Nome" name="nome" span={5} />
                        <FormSelect
                            showSearch
                            label="Controle RFA"
                            name="controleRfa"
                            placeholder="Selecione uma opção"
                            options={controleRfa && controleRfa.map(a => ({ text: a.planilhaRfa, value: a.planilhaRfa }))}
                            span={5}
                        />
                    </Widget>


                    <Widget title="Resultado">
                        <Table
                            id={'tabelaProgramaControleRfa'}
                            rowKey="id"
                            columns={colluns()}
                            pagination={false}
                            dataSource={resulProgramaControleRfa}
                        />
                    </Widget>

                </MasterDetailForm>

            </GridView>
        </SimpleView>
    );

}


export default Programa;